// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: oyxikxJz0w
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import CityLocCountCircleChart from "../../CityLocCountCircleChart"; // plasmic-import: HaRC1mxNKX/component
import { useScreenVariants as useScreenVariantsrrBukHdQcoc } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: rrBukHDQcoc/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicCitySummary.module.css"; // plasmic-import: oyxikxJz0w/css

export const PlasmicCitySummary__VariantProps = new Array(
  "notWrapped",
  "leftAligned"
);

export const PlasmicCitySummary__ArgProps = new Array(
  "cityH1",
  "cityLink",
  "numBrands",
  "numLocations"
);

function PlasmicCitySummary__RenderFunc(props) {
  const { variants, args, overrides, forNode } = props;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsrrBukHdQcoc()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(projectcss.all, projectcss.root_reset, sty.root, {
        [sty.rootleftAligned]: hasVariant(
          variants,
          "leftAligned",
          "leftAligned"
        )
      })}
    >
      <a
        data-plasmic-name={"cityLink"}
        data-plasmic-override={overrides.cityLink}
        className={classNames(projectcss.all, projectcss.a, sty.cityLink, {
          [sty.cityLinkleftAligned]: hasVariant(
            variants,
            "leftAligned",
            "leftAligned"
          ),

          [sty.cityLinknotWrapped]: hasVariant(
            variants,
            "notWrapped",
            "notWrapped"
          )
        })}
        href={args.cityLink}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox__vZhYg, {
            [sty.freeBoxleftAligned__vZhYGrUgth]: hasVariant(
              variants,
              "leftAligned",
              "leftAligned"
            ),

            [sty.freeBoxnotWrapped__vZhYgkenmz]: hasVariant(
              variants,
              "notWrapped",
              "notWrapped"
            )
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__hvkXe, {
              [sty.freeBoxleftAligned__hvkXErUgth]: hasVariant(
                variants,
                "leftAligned",
                "leftAligned"
              ),

              [sty.freeBoxnotWrapped__hvkXekenmz]: hasVariant(
                variants,
                "notWrapped",
                "notWrapped"
              )
            })}
          >
            <div
              className={classNames(projectcss.all, sty.freeBox__jSk8K, {
                [sty.freeBoxleftAligned__jSk8KrUgth]: hasVariant(
                  variants,
                  "leftAligned",
                  "leftAligned"
                )
              })}
            >
              <h1
                data-plasmic-name={"cityH1"}
                data-plasmic-override={overrides.cityH1}
                className={classNames(
                  projectcss.all,
                  projectcss.h1,
                  sty.cityH1,
                  {
                    [sty.cityH1leftAligned]: hasVariant(
                      variants,
                      "leftAligned",
                      "leftAligned"
                    )
                  }
                )}
              >
                {p.renderPlasmicSlot({
                  defaultContents: "Boston",
                  value: args.cityH1,
                  className: classNames(sty.slotTargetCityH1, {
                    [sty.slotTargetCityH1leftAligned]: hasVariant(
                      variants,
                      "leftAligned",
                      "leftAligned"
                    )
                  })
                })}
              </h1>

              <div
                data-plasmic-name={"numBrands"}
                data-plasmic-override={overrides.numBrands}
                className={classNames(projectcss.all, sty.numBrands, {
                  [sty.numBrandsleftAligned]: hasVariant(
                    variants,
                    "leftAligned",
                    "leftAligned"
                  )
                })}
              >
                {p.renderPlasmicSlot({
                  defaultContents: "36 brands",
                  value: args.numBrands
                })}
              </div>

              <div
                data-plasmic-name={"numLocations"}
                data-plasmic-override={overrides.numLocations}
                className={classNames(projectcss.all, sty.numLocations)}
              >
                {p.renderPlasmicSlot({
                  defaultContents: "2000+ locations",
                  value: args.numLocations
                })}
              </div>
            </div>

            {(
              hasVariant(globalVariants, "screen", "mobileOnly") ? true : true
            ) ? (
              <div className={classNames(projectcss.all, sty.freeBox___3D7Ah)}>
                <CityLocCountCircleChart
                  data-plasmic-name={"cityLocCountCircleChart"}
                  data-plasmic-override={overrides.cityLocCountCircleChart}
                  className={classNames(
                    "__wab_instance",
                    sty.cityLocCountCircleChart
                  )}
                />
              </div>
            ) : null}
          </div>
        </div>
      </a>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "cityLink",
    "cityH1",
    "numBrands",
    "numLocations",
    "cityLocCountCircleChart"
  ],

  cityLink: [
    "cityLink",
    "cityH1",
    "numBrands",
    "numLocations",
    "cityLocCountCircleChart"
  ],

  cityH1: ["cityH1"],
  numBrands: ["numBrands"],
  numLocations: ["numLocations"],
  cityLocCountCircleChart: ["cityLocCountCircleChart"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicCitySummary__ArgProps,
      internalVariantPropNames: PlasmicCitySummary__VariantProps
    });

    return PlasmicCitySummary__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCitySummary";
  } else {
    func.displayName = `PlasmicCitySummary.${nodeName}`;
  }
  return func;
}

export const PlasmicCitySummary = Object.assign(
  // Top-level PlasmicCitySummary renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    cityLink: makeNodeComponent("cityLink"),
    cityH1: makeNodeComponent("cityH1"),
    numBrands: makeNodeComponent("numBrands"),
    numLocations: makeNodeComponent("numLocations"),
    cityLocCountCircleChart: makeNodeComponent("cityLocCountCircleChart"),
    // Metadata about props expected for PlasmicCitySummary
    internalVariantProps: PlasmicCitySummary__VariantProps,
    internalArgProps: PlasmicCitySummary__ArgProps
  }
);

export default PlasmicCitySummary;
/* prettier-ignore-end */
